<template>
  <div>
    <el-dialog
      class="process-mind-map-dialog process-mind-map-source-dialog fishbone-form-detail-dialog prd-chkrpt-list-dialog"
      v-dialogDrag
      :visible.sync="innerVisible"
      width="96vw"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="loadData"
      @closed="resetData">
      <div slot="title" class="prd-chkrpt-dialog__title">
        <span>{{ $LANG('', '成品检验报告') }}</span>
      </div>
      <div class="prd-chkrpt-dialog__body">
        <div class="prd-chkrpt-dialog__toolbar">
          <el-input
            v-model="filters.productCode"
            size="mini"
            clearable
            :placeholder="$LANG('', '产品编码')"
            :aria-label="$LANG('', '产品编码')">
          </el-input>
          <el-input
            v-model="filters.productName"
            size="mini"
            clearable
            :placeholder="$LANG('', '产品名称')"
            :aria-label="$LANG('', '产品名称')">
          </el-input>
          <el-button class="prd-chkrpt-dialog__reset" size="mini" @click="resetFilters">{{ $LANG('', '重置') }}</el-button>
          <el-button
            class="prd-chkrpt-dialog__add"
            type="primary"
            size="mini"
            icon="iconfont icon-xinzeng"
            :disabled="addBool"
            @click="addRecord">
            {{ $LANG('0138', '新增') }}
          </el-button>
        </div>
        <el-table
          :data="filteredTableData"
          border
          size="small"
          ref="listTable"
          class="custom-table-border prd-chkrpt-dialog__table"
          v-loading="loading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          show-summary
          :summary-method="getSummary"
          :cell-style="{ padding: '2px' }"
          :header-cell-style="headStyle"
          cell-class-name="clearPadding2"
          height="calc(88vh - 97px)"
          highlight-current-row>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="getColumnMinWidth(item)">
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                disabled
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <el-link v-else-if="item.key === 'IDNO'" :underline="false" @click="openDetail(scope.row, 'view')">
                <span class="prd-chkrpt-dialog__idno">{{ displayText(scope.row[item.key]) }}</span>
              </el-link>
              <el-tag
                v-else-if="item.key === 'STFG'"
                size="mini"
                :type="getStatusTagType(scope.row[item.key])"
                effect="dark">
                {{ getStatusTextForRow(scope.row) }}
              </el-tag>
              <el-tag
                v-else-if="isYesNoField(item)"
                size="mini"
                :type="scope.row[item.key] === 'Y' ? 'success' : 'info'"
                effect="dark">
                {{ scope.row[item.key] === 'Y' ? $LANG('2047', '是') : $LANG('2044', '否') }}
              </el-tag>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$LANG('0330', '操作')"
            align="center"
            width="132">
            <template slot-scope="scope">
              <div class="prd-chkrpt-dialog__action-group">
                <el-tooltip :content="$LANG('0139', '查看')" placement="top" effect="light">
                  <el-button
                    class="prd-chkrpt-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-chakan"
                    :aria-label="$LANG('0139', '查看')"
                    @click="openDetail(scope.row, 'view')">
                  </el-button>
                </el-tooltip>
                <template v-if="scope.row.STFG === 'N'">
                  <el-tooltip v-if="!editBool" :content="$LANG('1639', '编辑')" placement="top" effect="light">
                    <el-button
                      class="prd-chkrpt-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-bianji"
                      :aria-label="$LANG('1639', '编辑')"
                      @click="openDetail(scope.row, 'edit')">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="prd-chkrpt-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-bianji"
                    disabled
                    :aria-label="$LANG('1639', '编辑')">
                  </el-button>
                  <el-tooltip v-if="!appBool" :content="$LANG('0364', '确认')" placement="top" effect="light">
                    <el-button
                      class="prd-chkrpt-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-shenhe"
                      :aria-label="$LANG('0364', '确认')"
                      @click="setStatus(scope.row, 'K', $LANG('0364', '确认'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="prd-chkrpt-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-shenhe"
                    disabled
                    :aria-label="$LANG('0364', '确认')">
                  </el-button>
                </template>
                <template v-else-if="scope.row.STFG === 'K'">
                  <el-tooltip v-if="!appBool" :content="$LANG('0314', '弃认')" placement="top" effect="light">
                    <el-button
                      class="prd-chkrpt-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-fanshenhe"
                      :aria-label="$LANG('0314', '弃认')"
                      @click="setStatus(scope.row, 'N', $LANG('0314', '弃认'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="prd-chkrpt-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-fanshenhe"
                    disabled
                    :aria-label="$LANG('0314', '弃认')">
                  </el-button>
                  <el-tooltip v-if="!cfmBool" :content="$LANG('0134', '审核')" placement="top" effect="light">
                    <el-button
                      class="prd-chkrpt-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-shenhe"
                      :aria-label="$LANG('0134', '审核')"
                      @click="setStatus(scope.row, 'Y', $LANG('0134', '审核'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="prd-chkrpt-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-shenhe"
                    disabled
                    :aria-label="$LANG('0134', '审核')">
                  </el-button>
                </template>
                <template v-else-if="scope.row.STFG === 'Y'">
                  <el-tooltip v-if="!cfmBool" :content="$LANG('0137', '弃审')" placement="top" effect="light">
                    <el-button
                      class="prd-chkrpt-dialog__action-button"
                      type="text"
                      size="mini"
                      icon="iconfont icon-fanshenhe"
                      :aria-label="$LANG('0137', '弃审')"
                      @click="setStatus(scope.row, 'K', $LANG('0137', '弃审'))">
                    </el-button>
                  </el-tooltip>
                  <el-button
                    v-else
                    class="prd-chkrpt-dialog__action-button"
                    type="text"
                    size="mini"
                    icon="iconfont icon-fanshenhe"
                    disabled
                    :aria-label="$LANG('0137', '弃审')">
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog prd-chkrpt-detail-dialog"
      v-dialogDrag
      :visible.sync="detailVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetDetailData">
      <div slot="title" class="prd-chkrpt-dialog__title">
        <span>{{ detailMode === 'create' ? $LANG('0095', '新增记录') : (detailMode === 'edit' ? $LANG('0921', '编辑记录') : $LANG('0971', '资料明细')) }}</span>
      </div>
      <div class="prd-chkrpt-detail-dialog__body" v-loading="detailLoading">
        <div v-for="(gpitem, gpind) in formGroups" :key="gpind">
          <div class="process-dialog-section prd-chkrpt-detail-dialog__section">
            <span>{{ gpitem.gpnm }}</span>
          </div>
          <Form class="prd-chkrpt-detail-dialog__form" :model="mainRow" :label-width="120" label-position="right" inline>
            <div
              v-for="(item, index) in gpitem.gplist"
              :key="index"
              :class="getMainFormCellClass(item)">
              <FormItem
                v-if="item.fhide === 'N'"
                :class="item.edcss === 'textarea' ? 'prd-chkrpt-detail-dialog__form-item prd-chkrpt-detail-dialog__form-item--wide prd-chkrpt-detail-dialog__form-item--textarea' : 'prd-chkrpt-detail-dialog__form-item'"
                :prop="item.fldno">
                <template slot="label"><span v-if="item.notnull === 'Y'" class="prd-chkrpt-detail-dialog__required">*</span>{{ item.title }}</template>
                <el-select
                  v-if="item.key === 'FRUSER'"
                  size="medium"
                  :disabled="saveFlag"
                  filterable
                  :placeholder="$LANG('1664', '请选择')"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                  <el-option
                    v-for="(option, optIndex) in empArr"
                    :key="optIndex"
                    :disabled="option.STFG === 'X'"
                    :label="option.USERNM"
                    :value="option.USERNM">
                  </el-option>
                </el-select>
                <el-date-picker
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  type="date"
                  v-else-if="item.edcss === 'date'"
                  v-model="mainRow[item.fldno]"
                  clearable
                  value-format="yyyy-MM-dd"
                  style="width:100%">
                </el-date-picker>
                <el-input-number
                  size="medium"
                  :precision="item.dotnum"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'number'"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                </el-input-number>
                <el-checkbox
                  size="medium"
                  border
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'checkbox'"
                  true-label="Y"
                  false-label="N"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                </el-checkbox>
                <el-select
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  filterable
                  v-else-if="item.edcss === 'select'"
                  v-model="mainRow[item.fldno]"
                  style="width:100%">
                  <el-option
                    v-for="(option, optIndex) in comboArr[item.fldno] || []"
                    :key="optIndex"
                    :label="option.CNAME"
                    :value="option.CODE">
                  </el-option>
                </el-select>
                <el-input
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'button'"
                  v-model="mainRow[item.fldno]"
                  @focus="inputBtn(null, null, item.key)"
                  style="width:100%">
                </el-input>
                <el-input
                  size="medium"
                  :disabled="isMainFieldDisabled(item)"
                  v-else-if="item.edcss === 'textarea'"
                  resize="none"
                  type="textarea"
                  :rows="4"
                  v-model="mainRow[item.fldno]">
                </el-input>
                <el-input
                  size="medium"
                  :placeholder="item.holder"
                  :disabled="isMainFieldDisabled(item)"
                  v-else
                  v-model="mainRow[item.fldno]">
                </el-input>
              </FormItem>
            </div>
          </Form>
        </div>
        <div class="process-dialog-section prd-chkrpt-detail-dialog__section prd-chkrpt-detail-dialog__section--detail">
          <span>{{ $LANG('0109', '明细资料') }}</span>
          <el-button
            class="prd-chkrpt-detail-dialog__detail-add"
            type="primary"
            size="mini"
            icon="iconfont icon-xinzeng"
            :disabled="addBool || saveFlag"
            @click="addDetailRow">
            {{ $LANG('0087', '新增明细') }}
          </el-button>
        </div>
        <el-table
          :data="detailData"
          border
          size="small"
          ref="detailTable"
          class="custom-table-border prd-chkrpt-detail-dialog__table"
          show-summary
          :summary-method="getSummary"
          :cell-style="{ padding: '2px', 'font-size': '12px' }"
          cell-class-name="clearPadding2"
          height="34vh"
          highlight-current-row
          @row-click="rowClick">
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in visibleDetailColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot="header">{{ item.title }}<span v-if="item.notnull === 'Y'" class="prd-chkrpt-detail-dialog__required">*</span></template>
            <template slot-scope="scope">
              <span v-if="saveFlag">
                <el-checkbox
                  v-if="item.edcss === 'checkbox'"
                  disabled
                  true-label="Y"
                  false-label="N"
                  v-model="scope.row[item.key]">
                </el-checkbox>
                <span v-else-if="item.key === 'MATTY'" v-text="displayText(scope.row.CMATTY)"></span>
                <span v-else-if="item.key === 'REASON'" v-text="displayText(scope.row.REASONM)"></span>
                <span v-else v-text="displayText(scope.row[item.key])"></span>
              </span>
              <span v-else>
                <el-select
                  v-if="item.key === 'MATTY'"
                  size="mini"
                  filterable
                  v-model="scope.row[item.key]"
                  style="width:100%">
                  <el-option
                    v-for="(option, optIndex) in tyArr"
                    :key="optIndex"
                    :label="option.CNAME"
                    :value="option.SUBNO">
                  </el-option>
                </el-select>
                <el-input
                  v-else-if="item.edcss === 'button'"
                  size="mini"
                  v-model="scope.row[item.key]"
                  @focus="inputBtn(scope.row, scope.$index, item.key)"
                  style="width:100%">
                </el-input>
                <el-input
                  v-else-if="item.disabled === 'N' && item.edcss === 'number'"
                  type="number"
                  size="mini"
                  v-model="scope.row[item.key]"
                  @keydown.native="handleNumberKeydown"
                  style="width:100%">
                </el-input>
                <el-date-picker
                  v-else-if="item.edcss === 'date'"
                  :disabled="item.disabled !== 'N'"
                  type="date"
                  size="mini"
                  v-model="scope.row[item.key]"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  style="width:100%">
                </el-date-picker>
                <el-checkbox
                  v-else-if="item.edcss === 'checkbox'"
                  :disabled="item.disabled !== 'N'"
                  true-label="Y"
                  false-label="N"
                  size="mini"
                  v-model="scope.row[item.key]"
                  style="width:100%">
                </el-checkbox>
                <el-select
                  v-else-if="item.edcss === 'select'"
                  size="mini"
                  filterable
                  v-model="scope.row[item.key]"
                  style="width:100%">
                  <el-option
                    v-for="(option, optIndex) in comboArr[item.key] || []"
                    :key="optIndex"
                    :label="option.CNAME"
                    :value="option.CODE">
                  </el-option>
                </el-select>
                <el-input
                  v-else-if="item.disabled === 'N'"
                  size="mini"
                  v-model="scope.row[item.key]"
                  style="width:100%">
                </el-input>
                <span v-else v-text="displayText(scope.row[item.key])"></span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$LANG('0330', '操作')"
            align="center"
            width="70">
            <template slot-scope="scope">
              <el-button
                class="prd-chkrpt-dialog__detail-delete"
                type="text"
                size="mini"
                icon="iconfont icon-shanchu1"
                :disabled="saveFlag"
                @click="deleteDetailRow(scope.row, scope.$index)">
                {{ $LANG('0131', '删除') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="process-dialog-section prd-chkrpt-detail-dialog__section prd-chkrpt-detail-dialog__section--attachment">
          <span>{{ $LANG('0516', '上传附件') }}</span>
        </div>
        <div class="prd-chkrpt-detail-dialog__attachment-row">
          <Upload
            ref="upload"
            name="upfile"
            :data="uploadData"
            :show-upload-list="false"
            :before-upload="beforeImgFile"
            :on-success="successImgFile"
            :with-credentials="true" 
            :format="['jpg','jpeg','png','pdf']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            type="drag"
            :disabled="saveFlag"
            :on-progress="handleProgress"
            :action="uploadUrl"
            class="prd-chkrpt-detail-dialog__uploader">
            <div class="prd-chkrpt-detail-dialog__upload-inner">
              <el-image src="/assets/basedict/nopic.png" class="prd-chkrpt-detail-dialog__upload-img"></el-image>
              <p>{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
            </div>
          </Upload>
          <div class="prd-chkrpt-detail-dialog__attachment-list">
            <div v-for="(item, index) in imgData" :key="index" class="prd-chkrpt-detail-dialog__attachment-card">
              <div v-if="isPdfFile(item.FILEPATH)" class="prd-chkrpt-detail-dialog__pdf-frame">
                <iframe :src="item.FILEPATH" frameborder="0"></iframe>
              </div>
              <el-image
                v-else
                :preview-src-list="[item.FILEPATH]"
                fit="cover"
                class="prd-chkrpt-detail-dialog__attachment-img"
                :src="item.FILEPATH">
              </el-image>
              <div class="prd-chkrpt-detail-dialog__attachment-actions">
                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ, item.LSTSEQ, item.FILEPATH, index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                <el-link v-if="isPdfFile(item.FILEPATH)" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="prd-chkrpt-dialog__footer">
        <span class="prd-chkrpt-detail-dialog__status">
          <i v-if="mainRow.STFG === 'N'" class="iconfont icon-weishenhe3"></i>
          <i v-else-if="mainRow.STFG === 'K'" class="iconfont icon-shenhe"></i>
          <i v-else-if="mainRow.STFG === 'Y'" class="iconfont icon-yishenhe1"></i>
          <i v-else-if="mainRow.STFG === 'X'" class="iconfont icon-yizuofei"></i>
        </span>
        <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="detailVisible = false">{{ $LANG('0132', '取消') }}</el-button>
        <el-button
          type="primary"
          size="small"
          icon="iconfont icon-baocun"
          :disabled="saveFlag || saving || (detailMode === 'create' ? addBool : editBool)"
          @click="saveDetail">
          {{ $LANG('0130', '保存') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="process-mind-map-dialog prd-chkrpt-select-dialog"
      v-dialogDrag
      :visible.sync="selectVisible"
      :width="dialogWidth"
      append-to-body
      top="4vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div slot="title" class="prd-chkrpt-dialog__title">
        <span>{{ $LANG('0997', '选择记录') }}</span>
      </div>
      <div class="prd-chkrpt-select-dialog__body">
        <div class="prd-chkrpt-select-dialog__toolbar">
          <span class="prd-chkrpt-select-dialog__label">{{ $LANG('0681', '字段查询') }}</span>
          <el-select
            v-model="selectParam"
            :placeholder="$LANG('1675', '请选择列名')"
            filterable
            size="small"
            class="prd-chkrpt-select-dialog__field">
            <el-option
              v-for="item in selectVisibleColumns"
              :key="item.key"
              :label="item.title"
              :value="item.key">
            </el-option>
          </el-select>
          <el-select v-model="selectOper" size="small" class="prd-chkrpt-select-dialog__oper">
            <el-option
              v-for="item in operArr"
              :key="item.IDSEQ"
              :label="item.CNAME"
              :value="item.SUBNO">
            </el-option>
          </el-select>
          <el-input
            :placeholder="$LANG('1692', '请输入查询值')"
            clearable
            ref="selectQueryInput"
            v-model="selectText"
            @keyup.enter.native="querySelectRows"
            size="small"
            class="prd-chkrpt-select-dialog__input">
            <el-button size="small" slot="append" icon="el-icon-search" @click="querySelectRows"></el-button>
          </el-input>
          <div class="prd-chkrpt-select-dialog__actions">
            <el-button type="primary" size="small" icon="iconfont icon-yiqueren-xianxing" @click="confirmSelectRow">{{ $LANG('1638', '确定') }}</el-button>
            <el-button type="info" size="small" icon="iconfont icon-shanchu" @click="selectVisible = false">{{ $LANG('0132', '取消') }}</el-button>
          </div>
        </div>
        <el-table
          :data="selectPageRows"
          border
          size="small"
          ref="selectTableRef"
          header-cell-class-name="clearPadding"
          :header-cell-style="{ color: '#389', 'text-align': 'center' }"
          class="custom-table-border prd-chkrpt-select-dialog__table"
          :cell-style="{ padding: '2px', color: 'black', 'font-size': '12px' }"
          v-loading="selectLoading"
          :element-loading-text="$LANG('1959', '加载中')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 251, 255, 0.8)"
          height="68vh"
          @selection-change="handleSelectSelectionChange"
          @row-click="selectRowClick"
          @row-dblclick="selectRowDblClick"
          highlight-current-row>
          <el-table-column v-if="selectMode === 'multi'" type="selection" width="48" fixed></el-table-column>
          <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
          <el-table-column
            v-for="item in selectVisibleColumns"
            :key="item.key"
            :prop="item.key"
            :label="item.title"
            show-overflow-tooltip
            :align="item.align"
            :sortable="item.edcss !== 'checkbox' && item.sortable === 'N'"
            :min-width="item.width">
            <template slot-scope="scope">
              <el-checkbox
                v-if="item.edcss === 'checkbox'"
                disabled
                true-label="Y"
                false-label="N"
                v-model="scope.row[item.key]">
              </el-checkbox>
              <span v-else v-text="displayText(scope.row[item.key])"></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="prd-chkrpt-select-dialog__pager">
          <Page :total="selectDataCount" :page-size="selectRowSize" show-total :current="selectCurrent" @on-change="changeSelectPage"></Page>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="videoFlag"
      width="150px"
      append-to-body
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div slot="title" class="prd-chkrpt-upload-progress__title">
        <span>{{ $LANG('2052', '正在上传中') }}...</span>
      </div>
      <el-progress type="circle" :percentage="videoUploadPercent"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import { getBaseData, getTabColOrData } from '../../api/user'
import { getDate } from '../../api/Select'

export default {
  name: 'PrdChkRptDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      detailLoading: false,
      saving: false,
      detailVisible: false,
      detailMode: 'view',
      saveFlag: true,
      columns: [],
      tableData: [],
      filters: {
        productCode: '',
        productName: ''
      },
      formGroups: [],
      detailColumns: [],
      requiredFields: [],
      comboArr: {},
      mainRow: {},
      detailData: [],
      delDtlArr: [],
      imgData: [],
      delImg: [],
      uploadData: {},
      videoFlag: false,
      videoUploadPercent: 0,
      fileName: '',
      Accept: 'png,jpg,jpeg,gif,tiff,pdf',
      uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
      empArr: [],
      tyArr: [],
      prodColumns: [],
      chkColumns: [],
      selectVisible: false,
      selectColumns: [],
      selectTable: '',
      selectKey2: '',
      selectValue2: '',
      selectUseCorpid: true,
      selectMode: 'single',
      selectRow: null,
      selectIndex: -1,
      selectKey: '',
      selectParam: '',
      selectText: '',
      selectOper: 'like',
      selectLoading: false,
      selectSelectedRow: {},
      selectSelectedRows: [],
      selectRows: [],
      selectPageRows: [],
      selectDataCount: 0,
      selectCurrent: 1,
      selectRowSize: 50,
      operArr: [],
      currentDetailIndex: 0,
      addBool: false,
      editBool: false,
      cfmBool: false,
      appBool: false
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    dialogWidth: function () {
      return (window.innerWidth - 140) + 'px'
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) { return item.thide === 'N' })
    },
    filteredTableData: function () {
      var productCode = String(this.filters.productCode || '').trim().toLowerCase()
      var productName = String(this.filters.productName || '').trim().toLowerCase()
      return this.tableData.filter(function (row) {
        var rowProductCode = String(row.PRDNO || '').toLowerCase()
        var rowProductName = String(row.PRDNM || '').toLowerCase()
        return (!productCode || rowProductCode.indexOf(productCode) !== -1) &&
          (!productName || rowProductName.indexOf(productName) !== -1)
      })
    },
    visibleDetailColumns: function () {
      return this.detailColumns.filter(function (item) { return item.thide === 'N' })
    },
    selectVisibleColumns: function () {
      return this.selectColumns.filter(function (item) { return item.thide === 'N' && item.key !== 'SEL' })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
    vUsernm: function () {
      return this.$cookies.get('v_usernm')
    },
    vAdmin: function () {
      return this.$cookies.get('v_admin')
    },
    vCorpid: function () {
      return (this.getNodeData() && this.getNodeData().CORPID) || this.$cookies.get('v_corpid')
    },
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    },
    formGroupUrl: function () {
      return  'xuper_auth/getFormGroup'
    },
    noauthUrl: function () {
      return  'xuper_auth/getBaseData'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.detailVisible = false
      this.selectVisible = false
      this.resetFilters()
      this.resetDetailData()
    },
    resetFilters: function () {
      this.filters.productCode = ''
      this.filters.productName = ''
    },
    resetDetailData: function () {
      this.detailLoading = false
      this.saving = false
      this.detailMode = 'view'
      this.saveFlag = true
      this.formGroups = []
      this.detailColumns = []
      this.requiredFields = []
      this.comboArr = {}
      this.mainRow = {}
      this.detailData = []
      this.delDtlArr = []
      this.imgData = []
      this.delImg = []
      this.uploadData = {}
      this.videoFlag = false
      this.videoUploadPercent = 0
      this.fileName = ''
      this.currentDetailIndex = 0
      this.selectColumns = []
      this.selectTable = ''
      this.selectKey2 = ''
      this.selectValue2 = ''
      this.selectUseCorpid = true
      this.selectMode = 'single'
      this.selectRow = null
      this.selectIndex = -1
      this.selectKey = ''
      this.resetSelectData()
    },
    loadData: function () {
      this.loading = true
      Promise.all([
        this.loadListColumns(),
        this.loadRows(),
        this.loadPermission(),
        this.loadRequiredFields(),
        this.loadEmployeeRows(),
        this.loadTypeRows(),
        this.loadProdColumns(),
        this.loadChkColumns(),
        this.loadOperRows()
      ]).then(function (result) {
        this.columns = result[0] || []
        this.tableData = result[1] || []
        this.requiredFields = result[3] || []
        this.empArr = result[4] || []
        this.tyArr = result[5] || []
        this.prodColumns = result[6] || []
        this.chkColumns = result[7] || []
        this.operArr = result[8] || []
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    normalizeResultRows: function (res, silent) {
      var result = res && res && res.result
      if (Array.isArray(result)) return result
      if (result && !silent) this.$emit('error', String(result).split('\n')[0] || this.$LANG('1442', '提示'))
      return []
    },
    reloadAfterChange: function () {
      return this.loadRows().then(function (rows) {
        this.tableData = rows || []
        this.$emit('changed')
        this.$nextTick(function () {
          if (this.$refs.listTable && this.$refs.listTable.doLayout) this.$refs.listTable.doLayout()
        })
      }.bind(this))
    },
    loadPermission: function () {
      this.addBool = false
      this.editBool = false
      this.cfmBool = false
      this.appBool = false
      return getTabColOrData(this.tableUrl,  'v_sys_user_priv', 'userno', this.vUsername, 'frmidseq', '412736', '', '', '').then(function (res) {
        if (this.vAdmin !== 'N') return
        var rows = this.normalizeResultRows(res, true)
        var row = rows[0] || {}
        this.addBool = row.ISADD === 'N'
        this.editBool = row.ISUPD === 'N'
        this.cfmBool = row.ISCFM === 'N'
        this.appBool = row.ISEXP === 'N'
      }.bind(this))
    },
    loadRequiredFields: function () {
      return getTabColOrData(this.tableUrl,  'v_sys_form_fld', 'idseq', '412736', 'LSTSEQ', '1', 'NOTNULL', 'Y', '').then(function (res) {
        return this.normalizeResultRows(res, true).map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    loadListColumns: function () {
      return this.loadColumns('1')
    },
    loadDetailColumns: function () {
      return this.loadColumns('2')
    },
    loadProdColumns: function () {
      return this.loadColumnsByForm('412736', '3')
    },
    loadChkColumns: function () {
      return this.loadColumnsByForm('412736', '4')
    },
    loadColumns: function (lstseq, orderBy) {
      return this.loadColumnsByForm('412736', lstseq, orderBy)
    },
    loadColumnsByForm: function (formId, lstseq, orderBy) {
      return getTabColOrData(this.tableUrl, 'v_sys_form_fld', 'idseq', formId, 'lstseq', lstseq, '', '', orderBy || ' order by sortby,lstseq').then(function (res) {
        var list = this.normalizeResultRows(res, true)
        return list.map(function (item) {
          return this.normalizeColumn(item)
        }.bind(this))
      }.bind(this))
    },
    normalizeColumn: function (item) {
      return {
        title: this.$translate.getColTitle(item, this.$store.state.lang),
        key: item.key || item.FLDNO,
        fldno: item.FLDNO || item.key,
        align: item.align,
        width: item.width,
        thide: item.THIDE,
        fhide: item.FHIDE,
        edcss: item.EDCSS,
        disabled: item.DISABLED,
        dotnum: item.DOTNUM,
        sortable: item.SORTABLE,
        notnull: item.NOTNULL,
        combo: item.COMBO,
        holder: item.HOLDER
      }
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,
 
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        payload.p_key3,
        payload.p_value3,
        payload.p_cond
      ).then(function (res) {
        return this.normalizeResultRows(res)
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
        return []
      }.bind(this))
    },
    loadEmployeeRows: function () {
      return getBaseData(this.tableUrl + '', 'CORPID', this.vCorpid, 'ISOUT', 'N', 'V_SYS_USER', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    loadTypeRows: function () {
      return getBaseData(this.noauthUrl, 'PARENTNO', '16224', '', '', 'v_sys_base', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    loadOperRows: function () {
      return getBaseData(this.noauthUrl, 'PARENTNO', '15995', '', '', 'v_sys_base', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var params = {
        ORDNO: row.ORDNO,
        MATNO: row.MATNO,
        CORPID: row.CORPID
      }
      var missing = []
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    escapeQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: '',
        p_value: '',
        p_key2: 'CORPID',
        p_value2: params.CORPID,
        p_key3: '',
        p_value3: '',
        p_table: 'v_QC_PRD',
        p_cond: " and ORDNO like '%" + this.escapeQueryValue(params.ORDNO) + "%' and PRDNO like '%" + this.escapeQueryValue(params.MATNO) + "%' order by ORDNO desc"
      }
    },
    addRecord: function () {
      if (this.addBool) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = 'create'
      this.saveFlag = false
      this.mainRow = {
        DTTM: getDate('day'),
        IDSEQ: '',
        STFG: 'N',
        LVL: '416999',
        QARESULT: '417007',
        CORPID: this.vCorpid
      }
      this.detailData = []
      this.delDtlArr = []
      this.imgData = []
      this.delImg = []
      Promise.all([
        this.loadFormGroups(),
        this.loadDetailColumns(),
        this.loadFormCombos()
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.detailColumns = result[1] || []
        this.comboArr = result[2] || {}
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    openDetail: function (row, mode) {
      if (!row) return
      if (mode === 'edit' && this.editBool) return
      this.detailVisible = true
      this.detailLoading = true
      this.detailMode = mode === 'edit' ? 'edit' : 'view'
      this.saveFlag = this.detailMode !== 'edit' || row.STFG === 'Y'
      this.mainRow = JSON.parse(JSON.stringify(Object.assign({}, row, { IDSEQ: row.IDSEQ })))
      this.delDtlArr = []
      Promise.all([
        this.loadFormGroups(),
        this.loadDetailColumns(),
        this.loadFormCombos(),
        this.loadDetailRows(row.IDSEQ),
        this.loadImageRows(row.IDSEQ)
      ]).then(function (result) {
        this.formGroups = result[0] || []
        this.detailColumns = result[1] || []
        this.comboArr = result[2] || {}
        this.detailData = result[3] || []
        this.imgData = result[4] || []
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.detailLoading = false
      }.bind(this))
    },
    loadFormGroups: function () {
      return getTabColOrData(this.formGroupUrl, 'v_sys_form_fld', 'idseq', '412736', 'gpnm,gpsort', '', 'lstseq', '1', ' order by gpsort').then(function (res) {
        var groups = this.normalizeResultRows(res, true)
        return groups.map(function (group) {
          var nextGroup = Object.assign({}, group)
          nextGroup.gplist = (group.gplist || []).map(function (item) {
            return this.normalizeColumn(item)
          }.bind(this)).filter(function (item) {
            return item && item.fhide === 'N'
          })
          return nextGroup
        }.bind(this)).filter(function (group) {
          return group.gplist && group.gplist.length
        })
      }.bind(this))
    },
    loadFormCombos: function () {
      return getTabColOrData(this.tableUrl,   'v_sys_form_fld', 'idseq', '412736', 'edcss', 'select', '', '', ' and lstseq in (1,2)').then(function (res) {
        var fields = this.normalizeResultRows(res, true)
        return Promise.all(fields.map(function (field) {
          return this.loadComboOptions(field)
        }.bind(this))).then(function (results) {
          var comboMap = {}
          results.forEach(function (item) {
            if (item.fldno) comboMap[item.fldno] = item.options
            if (item.key) comboMap[item.key] = item.options
          })
          return comboMap
        })
      }.bind(this))
    },
    loadComboOptions: function (field) {
      if (!field || !field.COMBO) return Promise.resolve({ fldno: field && field.FLDNO, key: field && field.key, options: [] })
      return getTabColOrData(this.noauthUrl,  'v_sys_base', 'parentno', field.COMBO, '', '', '', '', '').then(function (res) {
        return {
          fldno: field.FLDNO,
          key: field.key,
          options: this.normalizeResultRows(res, true)
        }
      }.bind(this))
    },
    loadDetailRows: function (idseq) {
      if (!idseq) return Promise.resolve([])
      return getTabColOrData(this.tableUrl,   'v_QC_PRDdtl', 'idseq', idseq, '', '', '', '', ' ORDER BY lstseq').then(function (res) {
        return this.normalizeResultRows(res)
      }.bind(this))
    },
    loadImageRows: function (idseq) {
      if (!idseq) return Promise.resolve([])
      return getTabColOrData(this.tableUrl,  'V_mat_img', 'idseq', idseq, '', '', '', '', '').then(function (res) {
        return this.normalizeResultRows(res, true)
      }.bind(this))
    },
    getMainFormCellClass: function (item) {
      var classes = ['prd-chkrpt-detail-dialog__form-cell']
      if (item && item.edcss === 'textarea') classes.push('prd-chkrpt-detail-dialog__form-cell--wide')
      if (this.isMainFieldDisabled(item)) classes.push('prd-chkrpt-detail-dialog__form-cell--disabled')
      return classes
    },
    isMainFieldDisabled: function (item) {
      return this.saveFlag || (item && item.disabled === 'Y')
    },
    addDetailRow: function () {
      if (this.addBool || this.saveFlag) return
      this.selectKey = 'CHKNO'
      this.selectMode = 'multi'
      this.selectColumns = this.chkColumns
      this.selectTable = 'V_BS_CHKITM'
      this.selectKey2 = ''
      this.selectValue2 = ''
      this.selectUseCorpid = true
      this.selectRow = null
      this.selectIndex = -1
      this.resetSelectData()
      this.selectVisible = true
      this.$nextTick(function () {
        this.initSelectParam()
        this.querySelectRows()
      })
    },
    deleteDetailRow: function (row, index) {
      if (this.saveFlag) return
      if (row && row.LSTSEQ) this.delDtlArr.push(row)
      this.detailData.splice(index, 1)
    },
    validateDetail: function () {
      var missingTitle = ''
      this.requiredFields.some(function (item) {
        if (!this.mainRow[item.fldno]) {
          missingTitle = item.title
          return true
        }
        return false
      }.bind(this))
      if (missingTitle) {
        this.$emit('error', missingTitle + this.$LANG('2051', '不能为空'))
        return false
      }
      return true
    },
    saveDetail: function () {
      if (this.saveFlag || this.saving) return
      if (this.detailMode === 'create' && this.addBool) return
      if (this.detailMode === 'edit' && this.editBool) return
      if (!this.validateDetail()) return
      this.saving = true
      this.$axios({
        method: 'post',
        url:  'xuper_auth/formOneSave',
        data: { p_json: JSON.stringify(Object.assign({}, this.mainRow, { CORPID: this.vCorpid })), p_table: 'QC_PRD', frmid: '412736' }
      }).then(function (res) {
        if (res && res.result === 'OK') {
          var idseq = res.idseq
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/batDtlSave2',
            data: { p_json: JSON.stringify(this.detailData), p_table: 'QC_PRDDTL', p_idseq: idseq, p_action: 'S' }
          }).then(function () {
            return this.deleteRemovedDetailRows(idseq)
          }.bind(this)).then(function () {
            return this.saveImageRows(idseq)
          }.bind(this)).then(function () {
            return this.deleteRemovedImageRows()
          }.bind(this)).then(function () {
            this.detailVisible = false
            return this.reloadAfterChange()
          }.bind(this))
        }
        this.$emit('error', (res && res.result) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.saving = false
      }.bind(this))
    },
    deleteRemovedDetailRows: function (idseq) {
      var promise = Promise.resolve()
      this.delDtlArr.forEach(function (row) {
        promise = promise.then(function () {
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/delTabRec',
            data: { p_key: 'idseq', p_value: idseq, p_key2: 'lstseq', p_value2: row.LSTSEQ, p_table: 'QC_PRDdtl', p_action: 'D' }
          })
        }.bind(this))
      }.bind(this))
      return promise
    },
    saveImageRows: function (idseq) {
      var promise = Promise.resolve()
      this.imgData.forEach(function (row) {
        promise = promise.then(function () {
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/tableBodySave',
            data: { p_json: JSON.stringify(Object.assign({}, row)), p_table: 'mat_img', p_idseq: idseq }
          })
        }.bind(this))
      }.bind(this))
      return promise
    },
    deleteRemovedImageRows: function () {
      var promise = Promise.resolve()
      this.delImg.forEach(function (row) {
        promise = promise.then(function () {
          return this.$axios({
            method: 'post',
            url:  'xuper_auth/delTabRec',
            data: { p_key: 'idseq', p_value: row.IDSEQ, p_key2: 'lstseq', p_value2: row.LSTSEQ, p_key5: 'filepath', p_value5: row.FILEPATH, p_table: 'mat_img' }
          })
        }.bind(this))
      }.bind(this))
      return promise
    },
    setStatus: function (row, value, statusText) {
      if (!row) return
      if ((value === 'K' && row.STFG === 'N') || (value === 'N' && row.STFG === 'K')) {
        if (this.appBool) return
      } else if (this.cfmBool) {
        return
      }
      statusText = statusText || this.getStatusText(value)
      if (value === 'K' && row.FRUSER === this.vUsernm) {
        this.$emit('error', this.$LANG('1889', '提出者与确认人不能相同，请核查'))
        return
      }
      this.$confirm(this.$LANG('1564', '你确定要') + statusText + this.$LANG('1565', '此单据吗?'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        type: 'info'
      }).then(function () {
        var cond = this.buildStatusCond(value)
        return this.$axios({
          method: 'post',
          url:  'xuper_auth/updateRec',
          data: { p_key: 'idseq', p_value: row.IDSEQ, p_table: 'QC_PRD', p_cond: cond }
        }).then(function (res) {
          if (res && res.code === '200') return this.reloadAfterChange()
          this.$emit('error', (res && (res.message || res.result)) || this.$LANG('1442', '提示'))
        }.bind(this))
      }.bind(this)).catch(function () {})
    },
    getStatusText: function (value) {
      if (value === 'K') return this.$LANG('0364', '确认')
      if (value === 'Y') return this.$LANG('0134', '审核')
      return this.$LANG('0314', '弃认')
    },
    buildStatusCond: function (value) {
      if (value === 'K') {
        return " set stfg='K',appuser='" + this.escapeQueryValue(this.vUsernm) + "',appdttm='" + getDate('full') + "',chkuser=null,chkdttm=null"
      }
      if (value === 'Y') {
        return " set stfg='Y',chkuser='" + this.escapeQueryValue(this.vUsernm) + "',chkdttm='" + getDate('full') + "'"
      }
      return " set stfg='" + this.escapeQueryValue(value) + "',chkuser='',chkdttm='',appuser='',appdttm=''"
    },
    rowClick: function (row) {
      this.currentDetailIndex = row && row.index !== undefined ? row.index : this.detailData.indexOf(row)
    },
    inputBtn: function (row, index, key) {
      this.selectKey = key
      this.selectRow = row
      this.selectIndex = index === null || index === undefined ? -1 : index
      this.resetSelectData()
      this.selectMode = 'single'
      this.selectColumns = this.prodColumns
      this.selectTable = 'v_orditm'
      this.selectKey2 = ''
      this.selectValue2 = ''
      this.selectUseCorpid = true
      this.selectVisible = true
      this.$nextTick(function () {
        this.initSelectParam()
        this.querySelectRows()
      })
    },
    resetSelectData: function () {
      this.selectParam = ''
      this.selectText = ''
      this.selectOper = 'like'
      this.selectLoading = false
      this.selectSelectedRow = {}
      this.selectSelectedRows = []
      this.selectRows = []
      this.selectPageRows = []
      this.selectDataCount = 0
      this.selectCurrent = 1
    },
    initSelectParam: function () {
      var firstIdColumn = this.selectVisibleColumns.filter(function (item) {
        return item.key === 'CHKNO' || item.key === 'ORDNO' || item.key === 'IDNO'
      })[0]
      this.selectParam = firstIdColumn ? firstIdColumn.key : ((this.selectVisibleColumns[0] && this.selectVisibleColumns[0].key) || '')
      if (this.$refs.selectQueryInput && this.$refs.selectQueryInput.focus) this.$refs.selectQueryInput.focus()
    },
    querySelectRows: function () {
      if (!this.selectTable) return
      this.selectLoading = true
      var cond = ''
      if (this.selectParam && this.selectText) {
        if (this.selectOper === 'like') {
          cond += " and upper(" + this.selectParam + ") like upper('%" + this.escapeQueryValue(this.selectText) + "%')"
        } else {
          cond += " and upper(" + this.selectParam + ')' + this.selectOper + "upper('" + this.escapeQueryValue(this.selectText) + "')"
        }
      }
      this.$axios({
        method: 'post',
        url:  'xuper_auth/getBaseData',
        data: {
          p_key: this.selectUseCorpid ? 'corpid' : '',
          p_value: this.selectUseCorpid ? this.vCorpid : '',
          p_key2: this.selectKey2,
          p_value2: this.selectValue2,
          p_cond: cond,
          p_table: this.selectTable
        }
      }).then(function (res) {
        this.selectRows = this.normalizeResultRows(res)
        this.selectSelectedRow = {}
        this.selectSelectedRows = []
        this.initSelectPage()
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
        this.selectRows = []
        this.initSelectPage()
      }.bind(this)).finally(function () {
        this.selectLoading = false
        this.$nextTick(function () {
          if (this.$refs.selectTableRef && this.$refs.selectTableRef.doLayout) this.$refs.selectTableRef.doLayout()
        })
      }.bind(this))
    },
    initSelectPage: function () {
      this.selectDataCount = this.selectRows.length
      this.selectCurrent = 1
      this.changeSelectPage(1)
    },
    changeSelectPage: function (page) {
      var start = (page - 1) * this.selectRowSize
      var end = page * this.selectRowSize
      this.selectCurrent = page
      this.selectPageRows = this.selectRows.slice(start, end)
    },
    selectRowClick: function (row, column) {
      this.selectSelectedRow = JSON.parse(JSON.stringify(row || {}))
      if (this.selectMode === 'multi' && column && column.type !== 'selection' && this.$refs.selectTableRef && this.$refs.selectTableRef.toggleRowSelection) {
        this.$refs.selectTableRef.toggleRowSelection(row)
      }
    },
    selectRowDblClick: function (row) {
      this.selectSelectedRow = JSON.parse(JSON.stringify(row || {}))
      if (this.selectMode === 'multi') {
        this.handleSelectSure([this.selectSelectedRow])
        return
      }
      this.confirmSelectRow()
    },
    handleSelectSelectionChange: function (rows) {
      this.selectSelectedRows = (rows || []).map(function (row) {
        return JSON.parse(JSON.stringify(row || {}))
      })
    },
    confirmSelectRow: function () {
      if (this.selectMode === 'multi') {
        if (this.selectSelectedRows.length) {
          this.handleSelectSure(this.selectSelectedRows)
        } else if (this.selectSelectedRow && (this.selectSelectedRow.IDSEQ || this.selectSelectedRow.CHKNO)) {
          this.handleSelectSure([this.selectSelectedRow])
        } else {
          this.$emit('error', this.$LANG('1695', '请选择一记录'))
        }
      } else if (this.selectSelectedRow && this.selectSelectedRow.IDSEQ) {
        this.handleSelectSure(this.selectSelectedRow)
      } else {
        this.$emit('error', this.$LANG('1695', '请选择一记录'))
      }
    },
    handleSelectSure: function (obj) {
      if (this.selectKey === 'CHKNO') {
        var rows = obj || []
        rows.forEach(function (item) {
          this.detailData.push({
            CHKNO: item.CHKNO,
            CHKNM: item.CHKNM,
            TOOLS: item.SUBNO,
            RESULTS: 'Y'
          })
        }.bind(this))
        this.selectVisible = false
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
        return
      }
      if (!this.selectRow) {
        Object.assign(this.mainRow, {
          ORDNO: obj.IDNO,
          PRDNO: obj.MATNO,
          PRDNM: obj.MATNM,
          PRDDESC: obj.MATDESC,
          CLNTNM: obj.CLNTNM,
          ORDTYNM: obj.ORDTYNM,
          QTY: obj.QTY
        })
      }
      this.selectVisible = false
    },
    handleNumberKeydown: function (event) {
      if (['e', 'E', '+'].indexOf(event.key) > -1) event.returnValue = false
    },
    pdfViewer: function (path) {
      var routeUrl = this.$router.resolve({
        path: '/fullPreview',
        query: { fileUrl: path }
      })
      window.open(routeUrl.href, '_blank')
    },
    imgDel: function (idseq, lstseq, path, index) {
      if (this.saveFlag) return
      this.$confirm(this.$LANG('1594', '你确定要删除此附件吗'), this.$LANG('1442', '提示'), {
        confirmButtonText: this.$LANG('1638', '确定'),
        cancelButtonText: this.$LANG('0132', '取消'),
        customClass: 'process-mind-map-message-box',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'info'
      }).then(function () {
        this.delImg.push({ IDSEQ: idseq, LSTSEQ: lstseq, FILEPATH: path })
        this.imgData.splice(index, 1)
      }.bind(this)).catch(function () {})
    },
    handleProgress: function (event) {
      this.videoFlag = true
      this.videoUploadPercent = Math.floor(event.percent)
    },
    handleFormatError: function (file) {
      this.$emit('error', this.$LANG('1455', '文件格式错误,') + file.name + this.$LANG('1431', ' 是不正确, 请选择pdf或图片格式'))
    },
    handleMaxSize: function (file) {
      this.$emit('error', file.name + this.$LANG('1561', '文件太大， 不能超出') + '2M')
    },
    successImgFile: function (res, file) {
      this.videoUploadPercent = 0
      this.videoFlag = false
      this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})  
    },
    beforeImgFile: function () {
      this.fileName = this.vUsername + getDate('year') + '-CK'
      this.uploadData = { 
          p_type:'IMG',
          p_path:'/web/web_images/material/',
 
       }
      return new Promise(function (resolve) {
        this.$nextTick(function () {
          resolve(true)
        })
      }.bind(this))
    },
    isPdfFile: function (path) {
      return String(path || '').toLowerCase().lastIndexOf('.pdf') > -1
    },
    isYesNoField: function (item) {
      return item && (item.edcss === 'checkbox' || item.key === 'ISGIVE' || item.key === 'ISCHK')
    },
    getStatusTagType: function (value) {
      if (value === 'Y') return 'success'
      if (value === 'K') return 'warning'
      if (value === 'X') return 'danger'
      return 'info'
    },
    getStatusTextForRow: function (row) {
      row = row || {}
      if (row.STFGNM) return row.STFGNM
      if (row.STFG === 'Y') return this.$LANG('1976', '已审核')
      if (row.STFG === 'K') return this.$LANG('0364', '确认')
      if (row.STFG === 'X') return this.$LANG('0257', '作废')
      return this.$LANG('2005', '未审核')
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    getColumnMinWidth: function (item) {
      item = item || {}
      var configuredWidth = parseInt(item.width, 10) || 0
      var title = String(item.title || '')
      var isSortable = item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'
      var titleWidth = Array.from(title).reduce(function (total, char) {
        return total + (/[\u4e00-\u9fff]/.test(char) ? 14 : 8)
      }, 0)
      var headerWidth = titleWidth + (isSortable ? 22 : 0) + 24
      return Math.max(configuredWidth, headerWidth)
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (this.getSummaryFields().indexOf(column.property) > -1) return 'color:red'
    },
    getSummaryFields: function () {
      return ['QTY', 'PRDQTY', 'CHKQTY', 'BADQTY', 'OKQTY', 'QUALQTY', 'NOQTY', 'SZQTY', 'LOOKQTY', 'OTHQTY']
    },
    getSummary: function (param) {
      var sums = []
      var sumFields = this.getSummaryFields()
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        if (sumFields.indexOf(column.property) === -1) return
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        var sumValue = values.reduce(function (prev, curr) {
          if (!isNaN(curr)) return Number(prev) + Number(curr)
          return prev
        }, 0)
        sums[index] = sumValue ? sumValue.toFixed(2) : ''
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped lang="less">
.prd-chkrpt-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.prd-chkrpt-dialog__body {
  min-height: 70vh;
}
.prd-chkrpt-dialog__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 8px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}
.prd-chkrpt-dialog__toolbar .el-input {
  width: 150px;
}
.prd-chkrpt-dialog__add {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 26px !important;
  min-height: 26px !important;
  padding: 0 10px !important;
  border-radius: 13px !important;
  font-size: 12px !important;
  line-height: 26px !important;
}
.prd-chkrpt-dialog__add i {
  margin-right: 4px !important;
  font-size: 14px !important;
  line-height: 14px !important;
}
.prd-chkrpt-dialog__table,
.prd-chkrpt-detail-dialog__table {
  width: 100%;
}
.prd-chkrpt-dialog__table {
  flex: 1 1 auto;
  min-height: 0;
}
.prd-chkrpt-dialog__idno {
  color: #606266;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid red;
}
.prd-chkrpt-dialog__action-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.prd-chkrpt-dialog__action-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 50% !important;
  color: #409eff;
  line-height: 32px !important;
}
.prd-chkrpt-dialog__action-button i {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
}
.prd-chkrpt-dialog__action-button ::v-deep i,
.prd-chkrpt-dialog__action-button ::v-deep [class^="iconfont"],
.prd-chkrpt-dialog__action-button ::v-deep [class*=" iconfont"] {
  display: inline-block;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 16px !important;
}
.prd-chkrpt-dialog__action-button:hover,
.prd-chkrpt-dialog__action-button:focus {
  background: rgba(64, 158, 255, .1);
  color: #1f78ff;
}
.prd-chkrpt-dialog__action-button.is-disabled,
.prd-chkrpt-dialog__action-button.is-disabled:hover,
.prd-chkrpt-dialog__action-button.is-disabled:focus {
  background: transparent;
  color: #c0c4cc;
}
.prd-chkrpt-detail-dialog__body {
  height: 82vh;
  padding: 14px 18px 20px;
  overflow-y: auto;
  background: #fff;
  box-sizing: border-box;
}
.prd-chkrpt-detail-dialog__section {
  margin: 8px 0 !important;
  padding: 0 2px;
}
.prd-chkrpt-detail-dialog__section--detail {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 !important;
}
.prd-chkrpt-detail-dialog__section--attachment {
  margin: 8px 0 !important;
}
.prd-chkrpt-detail-dialog__detail-add {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 26px !important;
  min-height: 26px !important;
  min-width: 78px !important;
  padding: 0 10px !important;
  border-radius: 13px !important;
  font-size: 12px !important;
  line-height: 26px !important;
}
.prd-chkrpt-detail-dialog__detail-add i {
  margin-right: 4px !important;
  font-size: 14px !important;
  line-height: 14px !important;
}
.prd-chkrpt-detail-dialog__form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 48px;
  row-gap: 16px;
  padding: 0 12px 12px;
  box-sizing: border-box;
}
.prd-chkrpt-detail-dialog__form-item {
  width: 100%;
  min-width: 0;
  margin: 0 !important;
}
.prd-chkrpt-detail-dialog__form-cell {
  min-width: 0;
  min-height: 32px;
}
.prd-chkrpt-detail-dialog__form-cell--wide {
  grid-column: 1 / -1;
}
.prd-chkrpt-detail-dialog__form-item--wide {
  width: 100%;
}
.prd-chkrpt-detail-dialog__table {
  margin-top: 0;
}
.prd-chkrpt-detail-dialog__table .el-table__body-wrapper {
  min-height: 260px;
}
.prd-chkrpt-detail-dialog__required {
  color: red;
}
.prd-chkrpt-dialog__detail-delete {
  color: #409eff;
}
.prd-chkrpt-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}
.prd-chkrpt-detail-dialog__status {
  min-width: 32px;
  color: red;
  font-size: 28px;
  line-height: 1;
}
.prd-chkrpt-detail-dialog__attachment-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 0 12px 18px;
  box-sizing: border-box;
}
.prd-chkrpt-detail-dialog__uploader {
  flex: 0 0 200px;
}
.prd-chkrpt-detail-dialog__upload-inner {
  width: 200px;
  height: 150px;
  padding: 1px 0;
  color: #515a6e;
  text-align: center;
  box-sizing: border-box;
}
.prd-chkrpt-detail-dialog__upload-img {
  width: 76px;
  height: 76px;
  margin-top: 24px;
}
.prd-chkrpt-detail-dialog__upload-inner p {
  margin: 5px 0 0;
  font-size: 12px;
}
.prd-chkrpt-detail-dialog__attachment-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
}
.prd-chkrpt-detail-dialog__attachment-card {
  width: 150px;
}
.prd-chkrpt-detail-dialog__attachment-img,
.prd-chkrpt-detail-dialog__pdf-frame {
  width: 150px;
  height: 125px;
  border: 1px solid #e8eaec;
  box-sizing: border-box;
}
.prd-chkrpt-detail-dialog__pdf-frame {
  overflow: hidden;
}
.prd-chkrpt-detail-dialog__pdf-frame iframe {
  width: 100%;
  height: 100%;
}
.prd-chkrpt-detail-dialog__attachment-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 150px;
  min-height: 25px;
  padding: 0 6px;
  background: #e8eaec;
  box-sizing: border-box;
}
.prd-chkrpt-select-dialog__body {
  height: 82vh;
  overflow: hidden;
  background: #fff;
}
.prd-chkrpt-select-dialog__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 10px;
  border-bottom: 2px solid #389;
  box-sizing: border-box;
}
.prd-chkrpt-select-dialog__label {
  flex: 0 0 auto;
  color: #606266;
  font-size: 12px;
  line-height: 32px;
}
.prd-chkrpt-select-dialog__field {
  width: 170px;
}
.prd-chkrpt-select-dialog__oper {
  width: 110px;
}
.prd-chkrpt-select-dialog__input {
  width: 280px;
}
.prd-chkrpt-select-dialog__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
}
.prd-chkrpt-select-dialog__actions .el-button + .el-button {
  margin-left: 0;
}
.prd-chkrpt-select-dialog__table {
  width: 100%;
}
.prd-chkrpt-select-dialog__pager {
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 8px;
  background: #fff;
  box-sizing: border-box;
}
.prd-chkrpt-upload-progress__title {
  min-height: 30px;
  padding-left: 5px;
  background: #409eff;
  color: #fff;
  font-size: 16px;
  line-height: 30px;
}
@media (max-width: 1200px) {
  .prd-chkrpt-detail-dialog__form {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 24px;
  }
}
</style>

<style lang="less">
.process-mind-map-dialog.prd-chkrpt-list-dialog {
  .el-table th > .cell {
    white-space: nowrap;
    word-break: keep-all;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 10px;
  }
  .prd-chkrpt-dialog__toolbar .el-input--mini .el-input__inner {
    height: 28px !important;
    min-height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
  }
  .prd-chkrpt-dialog__toolbar .el-input--mini .el-input__icon {
    height: 28px;
    line-height: 28px;
  }
  .prd-chkrpt-dialog__toolbar .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
    height: 100%;
    vertical-align: top;
  }
  .prd-chkrpt-dialog__reset {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
    line-height: 28px !important;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
.process-mind-map-dialog.prd-chkrpt-detail-dialog,
.process-mind-map-dialog.prd-chkrpt-select-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;
    border-radius: 8px;
    .el-dialog__body {
      position: absolute;
      left: 0;
      right: 0;
      top: 40px;
      bottom: 0;
      padding: 0;
      overflow: hidden;
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .custom-table-border .el-table__body td,
  .custom-table-border .el-table__header th {
    border-color: rgb(184, 181, 181);
    border-width: 1px;
  }
}
.process-mind-map-dialog.prd-chkrpt-detail-dialog {
  .el-dialog__body {
    bottom: 54px !important;
  }
  .prd-chkrpt-detail-dialog__form {
    .ivu-form-item {
      margin-bottom: 0 !important;
    }
    .ivu-form-item-label {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      height: 32px;
      width: 120px;
      padding: 0 12px 0 0;
      line-height: 32px;
      text-align: right;
      box-sizing: border-box;
      vertical-align: top;
    }
    .ivu-form-item-content {
      min-height: 32px;
      line-height: 32px;
    }
    .el-input,
    .el-select,
    .el-date-editor,
    .el-input-number {
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input__inner,
    .el-input--medium .el-input__inner,
    .el-select .el-input__inner,
    .el-date-editor .el-input__inner,
    .el-input-number .el-input__inner {
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner,
    .el-input__inner[disabled],
    .el-textarea__inner[disabled] {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #909399 !important;
      cursor: not-allowed !important;
    }
    .el-select .el-input.is-disabled .el-input__inner,
    .el-date-editor.el-input.is-disabled .el-input__inner,
    .el-input-number.is-disabled .el-input__inner {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #909399 !important;
      cursor: not-allowed !important;
    }
    .el-input__icon {
      line-height: 32px !important;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 32px;
      height: 30px !important;
      line-height: 30px !important;
    }
    .el-input-number .el-input__inner {
      padding-left: 36px;
      padding-right: 36px;
    }
    .prd-chkrpt-detail-dialog__form-cell {
      .el-input.el-input--medium,
      .el-select.el-select--medium,
      .el-date-editor.el-input.el-input--medium,
      .el-input-number.el-input-number--medium {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        line-height: 32px !important;
        vertical-align: top !important;
      }
      .el-input.el-input--medium .el-input__inner,
      .el-select.el-select--medium .el-input.el-input--medium .el-input__inner,
      .el-date-editor.el-input.el-input--medium .el-input__inner,
      .el-input-number.el-input-number--medium .el-input.el-input--medium .el-input__inner {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        line-height: 32px !important;
        box-sizing: border-box !important;
      }
      .el-input-number.el-input-number--medium {
        display: inline-flex !important;
        align-items: center !important;
      }
      .el-input-number.el-input-number--medium .el-input {
        display: block !important;
        height: 32px !important;
        line-height: 32px !important;
      }
      .el-input-number.el-input-number--medium .el-input__inner {
        padding-right: 36px !important;
        padding-left: 36px !important;
        vertical-align: top !important;
      }
      .el-input-number.el-input-number--medium .el-input-number__decrease,
      .el-input-number.el-input-number--medium .el-input-number__increase {
        top: 1px !important;
        width: 32px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
    }
    .el-input-number.is-disabled .el-input-number__decrease,
    .el-input-number.is-disabled .el-input-number__increase {
      border-color: #dcdfe6 !important;
      background-color: #f5f7fa !important;
      color: #c0c4cc !important;
      cursor: not-allowed !important;
    }
    .prd-chkrpt-detail-dialog__form-cell--disabled {
      .el-input__inner,
      .el-textarea__inner,
      .el-input-number__decrease,
      .el-input-number__increase {
        border-color: #dcdfe6 !important;
        background-color: #f5f7fa !important;
        color: #909399 !important;
        cursor: not-allowed !important;
      }
      .el-input,
      .el-select,
      .el-date-editor,
      .el-input-number {
        color: #909399 !important;
      }
      .el-input__prefix,
      .el-input__suffix,
      .el-input__icon,
      .el-select__caret {
        color: #c0c4cc !important;
      }
    }
  }
  .el-dialog__footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 54px;
    padding: 10px 18px;
    border-top: 1px solid #dcdfe6;
    background: #fff;
    box-sizing: border-box;
  }
}
.process-mind-map-dialog.prd-chkrpt-select-dialog {
  .el-dialog__body {
    bottom: 0;
  }
}
</style>
